import { Menu } from "antd";
import navigation from "../../navigation";
import "./navLink.scss";
import { useHistory, useLocation } from "react-router-dom";

interface NavLinkProps {
	closeNavbar: boolean;
	setCloseNavbar: any;
	isConnected: boolean;
}

const NavLinks = ({ setCloseNavbar, isConnected }: NavLinkProps) => {
	const history = useHistory();
	const location = useLocation();

	const handleNavigate = async (e: any) => {
		const clickedPath = e.key;
		// Find the clicked item in navigation
		const allItems = navigation({ isConnected }).flatMap((item) =>
			item.subMenu ? item.subMenu : [item],
		);
		const clickedItem = allItems.find((item) => item.path === clickedPath);

		// If action is 'api-get', reload page and navigate to the path
		if (clickedItem?.action === "api-get" && clickedItem?.path) {
			setCloseNavbar(true);
			// Using window.location.href to ensure cookies are preserved
			window.open("https://nft.monbase.com/bcc/wallet", "_blank");
		}

		// Default: navigate to the path
		history.push(clickedPath);
		setCloseNavbar(true);
	};

	return (
		<Menu
			className="menu"
			defaultSelectedKeys={[location.pathname]}
			mode="inline"
			onClick={handleNavigate}
		>
			{navigation({ isConnected })?.map((item) => {
				if (item.hidden) return null;
				if (item.subMenu) {
					return (
						<Menu.SubMenu key={item.title} title={item.title}>
							{item.subMenu.map((i) => (
								<Menu.Item key={i.path}>{i.title}</Menu.Item>
							))}
						</Menu.SubMenu>
					);
				} else {
					return <Menu.Item key={item.path}>{item.title}</Menu.Item>;
				}
			})}
		</Menu>
	);
};

export default NavLinks;
